module.exports = __webpack_public_path__ + "static/media/printer_anim.3f952a15.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/printer_anim.gif
// module id = 553
// module chunks = 0